import { computed, inject, Service } from '@angular/core';
import { KiwidSocketService } from 'app/core/socket/kiwid-socket.service';
import { IDataPagination } from 'app/core/models/api/data';
import { EEventKiwidSocket } from 'app/core/enums/socket.enum';
import {
    IBadgeMessageNotification,
    IEmitGetAllNotificationMessageSocket,
    INotificationMessage,
} from 'app/core/models/message/notification-message';

@Service()
export class NotificationMessageSocketService {
    private readonly kiwidSocketService = inject(KiwidSocketService);

    public readonly isConnected = computed(() => this.kiwidSocketService.isConnected());

    public get badgeNotification() {
        return this.kiwidSocketService.fromEvent<IBadgeMessageNotification>(EEventKiwidSocket.NOTIFICATION_MESSAGE_BADGE);
    }

    public emitMarkReadMessageNotification() {
        return this.kiwidSocketService.emitWithResponse<null>(EEventKiwidSocket.NOTIFICATION_MESSAGE_MARK_READ, null);
    }

    public emitJoinBadgeMessageNotification() {
        return this.kiwidSocketService.emitWithResponse<IBadgeMessageNotification>(EEventKiwidSocket.NOTIFICATION_MESSAGE_JOIN_BADGE, null);
    }

    public emitLeaveBadge() {
        return this.kiwidSocketService.emit(EEventKiwidSocket.NOTIFICATION_MESSAGE_LEAVE_BADGE);
    }

    public emitGetAllOrderMessage(data: IEmitGetAllNotificationMessageSocket) {
        return this.kiwidSocketService.emitWithResponse<IDataPagination<INotificationMessage[]>>(
            EEventKiwidSocket.NOTIFICATION_MESSAGE_GET_ALL,
            data,
        );
    }
}
